import _ from 'underscore';
import Promise from 'bluebird';

export default ({
  gridName,
  dateUtil,
  state,
  getSegPreference,
  getSegType,
  segmentTimeChecker,
  fetchPaginationConfig,
  customColumnPreference,
}) => {
  const formatDate = date => dateUtil.format(date, 'M/d/yyyy');
  const services = [state.getPromise('$daterange'), fetchPaginationConfig(gridName, 50)];
  if (getSegPreference && _.isFunction(getSegPreference)) {
    services.push(getSegPreference(gridName));
  }
  if (customColumnPreference) {
    services.push(customColumnPreference.getCustomColumnsPreference(gridName));
  }

  return Promise
    .all(services)
    .spread(((dateRange, { pageSize, orderbyInfo, sortableHeader }) => {
      const result = {
        dataSource: {
          query: {},
          options: {},
        },
        pageable: {},
        plugins: {
          pagination: {},
        },
      };

      result.pageable.pageSize = pageSize;
      result.plugins.pagination.pageSize = pageSize;

      result.dataSource.query.endDate = formatDate(dateRange.end);
      result.dataSource.query.startDate = formatDate(dateRange.start);

      if (dateRange.compared) {
        result.dataSource.query.comparisonEndDate = formatDate(dateRange.compared.end);
        result.dataSource.query.comparisonStartDate = formatDate(dateRange.compared.start);
      }

      if (getSegType && _.isFunction(getSegType)) {
        const segType = getSegType(gridName);
        if (segType && segType.segmentationType !== 'None' && segmentTimeChecker.isTimeRangeValid(segType.segmentationType)) {
          result.dataSource.query.SegmentationTypes = segType.segmentationType;
        }
      }

      if (orderbyInfo && orderbyInfo.length > 0) {
        result.dataSource.orderby = orderbyInfo;
        result.sortableHeader = _.pick(sortableHeader, 'name', 'directionIndex');
      }

      return result;
    }));
};
